import { sentPasswordResetLink } from "api/userManagement";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import ButtonComp from "themes/elements/Button";
import InputComp from "themes/elements/Input";
import style from "../auth.module.scss";

function OtpForm() {
  const navigate = useNavigate();
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(false);

  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const handleChange = (value) => {
    setEmail(value);
  };

  const handleSendPasswordResetLink = async () => {
    if (!emailRegex.test(email)) {
      toast.warning("Please enter a valid email address.");
      return;
    }

    setLoading(true);
    try {
      const response = await sentPasswordResetLink({
        email: email,
        action: "forgot-password",
      });
      if (response?.message) {
        toast.success(response?.message);
        // Navigate or further action
        navigate("/login");
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-column gap-4">
      <InputComp
        label="Email*"
        labelClass={style["input-label"]}
        placeholder="Enter your email"
        id="email"
        value={email}
        onChange={(e) => handleChange(e.target.value)}
      />
      <ButtonComp
        onClick={handleSendPasswordResetLink}
        disabled={loading}
        height={48}
        className="mt-4"
      >
        {loading ? "Sending..." : "Send Reset Link"}
      </ButtonComp>
    </div>
  );
}

export default OtpForm;
